import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DIALOG_HIDE_CLASS } from '../../shared/constants';
import { IRanchWellViewModel } from '../../ranch-settings/interfaces';
import { RanchWellFormComponent } from '../../ranch-settings/shared/ranch-well-form/main';

@Component({
	moduleId: module.id,
	selector: 'ranch-create-well-dialog',
	templateUrl: 'well-dialog.html'
})

export class RanchCreateWellDialog implements OnDestroy {
	@ViewChild(RanchWellFormComponent, { static: false })
	public wellForm: RanchWellFormComponent;

	private _subscriptions$: Subject<boolean>;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { well?: IRanchWellViewModel },
		private _dialogRef: MatDialogRef<RanchCreateWellDialog>
	) {
		this._subscriptions$ = new Subject();

		this._dialogRef.backdropClick()
			.pipe(takeUntil(this._subscriptions$)).subscribe(() => {
				this.close();
			});
	}

	public ngOnDestroy(): void {
		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public close(): void {
		if (!this.wellForm) {
			this.closeFinal();
			return;
		}

		this.wellForm.cancel();
	}

	public closeFinal(): void {
		this._dialogRef.close();
	}

	public hide(): void {
		this._dialogRef.addPanelClass(DIALOG_HIDE_CLASS);
	}

	public show(): void {
		this._dialogRef.removePanelClass(DIALOG_HIDE_CLASS);
	}

	public submit(well: IRanchWellViewModel): void {
		this._dialogRef.close(well);
	}
}
